import { CHECKOUT_DATA } from '@/constants/queries';
import { apiClient } from '@/services/apiClient';
import { useQuery } from '@tanstack/react-query';
import { Routes } from './routes';
import type { CheckoutData } from '@/types/checkout';
import { getCheckoutRequestOptions } from '@/utils/checkout';

export const useCheckoutData = ({ enableFetch }: { enableFetch: boolean }) => {
  return useQuery({
    queryKey: [CHECKOUT_DATA],
    enabled: enableFetch,
    queryFn: async (): Promise<CheckoutData> => {
      try {
        const response = await apiClient.get(Routes.CHECKOUT, getCheckoutRequestOptions());
        return response as CheckoutData;
      } catch {
        return {} as CheckoutData;
      }
    },
  });
};
